import {
  ApplicationConfig,
  importProvidersFrom,
  provideZoneChangeDetection,
  APP_INITIALIZER,
  isDevMode,
} from '@angular/core';
import { provideAnimations } from '@angular/platform-browser/animations';
import { DialogModule } from '@angular/cdk/dialog';
import { LucideAngularModule } from 'lucide-angular';
import {
  LayoutDashboard,
  Key,
  FileText,
  ScrollText,
  Route,
  ChartBar,
  Puzzle,
  Users,
  Shield,
  LogOut,
  User as UserIcon,
  UserCircle,
  Download,
  Bell,
  Menu,
  Activity,
  Globe,
  Server,
  Cpu,
  Brain,
  Wrench,
  Inbox,
} from 'lucide-angular';
import { provideRouter } from '@angular/router';
import {
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { provideServiceWorker } from '@angular/service-worker';
import { firstValueFrom, of } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { routes } from './app.routes';
import { JwtInterceptor } from './core/interceptors/jwt.interceptor';
import { AuthService } from './core/services/auth.service';

export function sessionInitializer(auth: AuthService): () => Promise<unknown> {
  return () => {
    if (!auth.isAuthenticated()) return Promise.resolve();
    return firstValueFrom(
      auth.validateSession().pipe(catchError(() => of(null)))
    );
  };
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideAnimations(),
    importProvidersFrom(
      DialogModule,
      LucideAngularModule.pick({
        LayoutDashboard,
        Key,
        FileText,
        ScrollText,
        Route,
        ChartBar,
        Puzzle,
        Users,
        Shield,
        LogOut,
        UserIcon,
        UserCircle,
        Download,
        Bell,
        Menu,
        Activity,
        Globe,
        Server,
        Cpu,
        Brain,
        Wrench,
        Inbox,
      })
    ),
    provideRouter(routes),
    provideHttpClient(withInterceptorsFromDi()),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: JwtInterceptor,
      multi: true,
    },
    {
      provide: APP_INITIALIZER,
      useFactory: sessionInitializer,
      multi: true,
      deps: [AuthService],
    },
    provideServiceWorker('ngsw-worker.js', {
      enabled: !isDevMode(),
      registrationStrategy: 'registerWhenStable:30000',
    }),
  ],
};
